import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default function Privacy() {
  return (
    <div className="home legal-page">
      <Navbar />

      <div className="customer-page legal-content-wrap">
        <div className="customer-page-header legal-hero">
          <h2>Privacy Policy</h2>
          <p>Last Updated: March 2026</p>
        </div>

        <section className="customer-card settings-section legal-section">
          <h3>1. Introduction</h3>
          <p>
            Shreeji Surti Swad ("we", "our", or "us") operates the Shreeji Surti Swad platform. This page informs you 
            of our policies regarding the collection, use, and disclosure of personal data when you use our service and 
            the choices you have associated with that data.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>2. Information Collection and Use</h3>
          <p>We collect several different types of information for various purposes:</p>
          <ul className="legal-list">
            <li><strong>Personal Data:</strong> Email, name, phone number, delivery address, payment information</li>
            <li><strong>Usage Data:</strong> Browser type, IP address, pages visited, time spent on pages</li>
            <li><strong>Location Data:</strong> GPS location for delivery services (with your consent)</li>
            <li><strong>Transaction Data:</strong> Order history, payment details, preferences</li>
          </ul>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>3. Use of Data</h3>
          <p>Shreeji Surti Swad uses the collected data for various purposes:</p>
          <ul className="legal-list">
            <li>To provide, maintain, and support our services</li>
            <li>To process your transactions and send related information</li>
            <li>To provide customer service and respond to your requests</li>
            <li>To send technical notices and updates</li>
            <li>To respond to your comments, questions, and requests</li>
            <li>To gather analysis or valuable information to improve our services</li>
            <li>To monitor usage of our services</li>
            <li>To detect, prevent, and address technical and security issues</li>
          </ul>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>4. Security of Data</h3>
          <p>
            The security of your data is important to us but remember that no method of transmission over the Internet 
            or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to 
            protect your data, we cannot guarantee its absolute security.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>5. Changes to This Privacy Policy</h3>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
            Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>6. Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:{" "}
            <strong>shreejisurtiswad@gmail.com</strong>
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
}
